
































































































































































import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import SignUpFirst from '@/components/gambling/SignUpFirst.vue'
import BettingModal from '@/components/gambling/BettingModal.vue'
import { BetObjectContext } from '@/utils/interfaces'

@Component({
  components: {
    SignUpFirst,
    BettingModal
  },
  computed: {
    ...mapState({
      isAuthenticated: ({ gamblingContext }: any): boolean => gamblingContext.isAuthenticated,
      fullName: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username
    })
  }
})

export default class GamblingBetting extends Vue {
  private bettingModal: boolean = false
  private allBets: undefined | object[] = []
  private upcomingBets: BetObjectContext[] = [
    {
      title: 'West ham vs Arsenal',
      bets: [ '3.30', '4.05', '2.06' ]
    },
    {
      title: 'Inter vs Barcelona',
      bets: [ '5.10', '4.45', '1.66' ]
    },
    {
      title: 'Chelsea vs Lille',
      bets: [ '1.22', '7.00', '17.50' ]
    }
  ]
  private clBets: BetObjectContext[] = [
    {
      title: 'Real madrid vs PSG',
      bets: [ '2.10', '3.05', '2.96' ]
    },
    {
      title: 'Man. city vs Din. Zagreb',
      bets: [ '1.83', '4.30', '3.75' ]
    },
    {
      title: 'Napoli vs Genk',
      bets: [ '1.16', '7.50', '17.99' ]
    }
  ]
  private elBets: BetObjectContext[] = [
    {
      title: 'FC Copenhagen vs Malmo FF',
      bets: [ '2.25', '3.25', '3.30' ]
    },
    {
      title: 'St. Liege vs Arsenal',
      bets: [ '3.60', '3.50', '2.00' ]
    },
    {
      title: 'Man utd. vs AZ Alkmaar',
      bets: [ '1.83', '3.60', '4.30' ]
    }
  ]
  private clearBets (): void {
    this.bettingModal = false
    this.allBets = []
  }
  private deleteBet (bet: BetObjectContext): void {
    this.allBets = this.allBets && this.allBets.filter((val: any) => val.title !== bet.title)
  }
  private placeBet (e: any, bet: BetObjectContext): void {
    const theBet = e.currentTarget.innerText.split('|')
    const betType = theBet[0].trimEnd()
    const odds = theBet[1].trimStart()
    const newBet = {
      title: bet.title,
      type: betType,
      odds,
      allOdds: bet.bets
    }
    const currentBets = this.allBets && this.allBets.filter((val: any) => val.title !== bet.title)
    currentBets ? currentBets.push(newBet) : []
    this.allBets = currentBets
  }
}
